
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f788Q", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $513b3aabfa44d17f$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $jpi63 = parcelRequire("jpi63");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-b87eea4244";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $513b3aabfa44d17f$var$BASE_URL = "https://www.atlassian.com";
const $513b3aabfa44d17f$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $513b3aabfa44d17f$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "canonical",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "alternate",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $513b3aabfa44d17f$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "alternate",
                        href: `${$513b3aabfa44d17f$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jpi63.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("bcztx", function(module, exports) {

var $1HaXd = parcelRequire("1HaXd");

var $aOqKz = parcelRequire("aOqKz");

var $jLuVq = parcelRequire("jLuVq");

var $bThnB = parcelRequire("bThnB");

var $lwkLP = parcelRequire("lwkLP");

var $2XKrJ = parcelRequire("2XKrJ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $827c5561c68e6bc0$var$Stack(entries) {
    var data = this.__data__ = new $1HaXd(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$827c5561c68e6bc0$var$Stack.prototype.clear = $aOqKz;
$827c5561c68e6bc0$var$Stack.prototype["delete"] = $jLuVq;
$827c5561c68e6bc0$var$Stack.prototype.get = $bThnB;
$827c5561c68e6bc0$var$Stack.prototype.has = $lwkLP;
$827c5561c68e6bc0$var$Stack.prototype.set = $2XKrJ;
module.exports = $827c5561c68e6bc0$var$Stack;

});
parcelRegister("aOqKz", function(module, exports) {

var $1HaXd = parcelRequire("1HaXd");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $7df352e5de6c01c4$var$stackClear() {
    this.__data__ = new $1HaXd;
    this.size = 0;
}
module.exports = $7df352e5de6c01c4$var$stackClear;

});

parcelRegister("jLuVq", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e63a6535405040df$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $e63a6535405040df$var$stackDelete;

});

parcelRegister("bThnB", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8a8250063136343f$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $8a8250063136343f$var$stackGet;

});

parcelRegister("lwkLP", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $faacb2b65c84a268$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $faacb2b65c84a268$var$stackHas;

});

parcelRegister("2XKrJ", function(module, exports) {

var $1HaXd = parcelRequire("1HaXd");

var $c4hom = parcelRequire("c4hom");

var $czXxz = parcelRequire("czXxz");
/** Used as the size to enable large array optimizations. */ var $22851ebfe11a0c7b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $22851ebfe11a0c7b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $1HaXd) {
        var pairs = data.__data__;
        if (!$c4hom || pairs.length < $22851ebfe11a0c7b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $czXxz(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $22851ebfe11a0c7b$var$stackSet;

});


parcelRegister("2et7A", function(module, exports) {

var $fbsQc = parcelRequire("fbsQc");
/** Built-in value references. */ var $1a037a7befeab862$var$Uint8Array = $fbsQc.Uint8Array;
module.exports = $1a037a7befeab862$var$Uint8Array;

});

parcelRegister("aN7pp", function(module, exports) {

var $4OMfZ = parcelRequire("4OMfZ");

var $kqsZv = parcelRequire("kqsZv");

var $ldH3d = parcelRequire("ldH3d");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7db43a3f56f13990$var$getAllKeys(object) {
    return $4OMfZ(object, $ldH3d, $kqsZv);
}
module.exports = $7db43a3f56f13990$var$getAllKeys;

});
parcelRegister("4OMfZ", function(module, exports) {

var $1qvtu = parcelRequire("1qvtu");

var $epu4p = parcelRequire("epu4p");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $382143c1a6fc866d$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $epu4p(object) ? result : $1qvtu(result, symbolsFunc(object));
}
module.exports = $382143c1a6fc866d$var$baseGetAllKeys;

});
parcelRegister("1qvtu", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $10a0a2596e41e14e$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $10a0a2596e41e14e$var$arrayPush;

});


parcelRegister("kqsZv", function(module, exports) {

var $4LG6t = parcelRequire("4LG6t");

var $g7VYj = parcelRequire("g7VYj");
/** Used for built-in method references. */ var $edecb95d732ed507$var$objectProto = Object.prototype;
/** Built-in value references. */ var $edecb95d732ed507$var$propertyIsEnumerable = $edecb95d732ed507$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $edecb95d732ed507$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $edecb95d732ed507$var$getSymbols = !$edecb95d732ed507$var$nativeGetSymbols ? $g7VYj : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $4LG6t($edecb95d732ed507$var$nativeGetSymbols(object), function(symbol) {
        return $edecb95d732ed507$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $edecb95d732ed507$var$getSymbols;

});
parcelRegister("4LG6t", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $378c36108c179673$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $378c36108c179673$var$arrayFilter;

});

parcelRegister("g7VYj", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $bbda44c1737be57f$var$stubArray() {
    return [];
}
module.exports = $bbda44c1737be57f$var$stubArray;

});



parcelRegister("iHlaM", function(module, exports) {

var $38RsQ = parcelRequire("38RsQ");

var $c4hom = parcelRequire("c4hom");

var $dc5b5 = parcelRequire("dc5b5");

var $c6mom = parcelRequire("c6mom");

var $liOEB = parcelRequire("liOEB");

var $Yvcvv = parcelRequire("Yvcvv");

var $jdev5 = parcelRequire("jdev5");
/** `Object#toString` result references. */ var $d9ccaaa112bb6e7e$var$mapTag = "[object Map]", $d9ccaaa112bb6e7e$var$objectTag = "[object Object]", $d9ccaaa112bb6e7e$var$promiseTag = "[object Promise]", $d9ccaaa112bb6e7e$var$setTag = "[object Set]", $d9ccaaa112bb6e7e$var$weakMapTag = "[object WeakMap]";
var $d9ccaaa112bb6e7e$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $d9ccaaa112bb6e7e$var$dataViewCtorString = $jdev5($38RsQ), $d9ccaaa112bb6e7e$var$mapCtorString = $jdev5($c4hom), $d9ccaaa112bb6e7e$var$promiseCtorString = $jdev5($dc5b5), $d9ccaaa112bb6e7e$var$setCtorString = $jdev5($c6mom), $d9ccaaa112bb6e7e$var$weakMapCtorString = $jdev5($liOEB);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $d9ccaaa112bb6e7e$var$getTag = $Yvcvv;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($38RsQ && $d9ccaaa112bb6e7e$var$getTag(new $38RsQ(new ArrayBuffer(1))) != $d9ccaaa112bb6e7e$var$dataViewTag || $c4hom && $d9ccaaa112bb6e7e$var$getTag(new $c4hom) != $d9ccaaa112bb6e7e$var$mapTag || $dc5b5 && $d9ccaaa112bb6e7e$var$getTag($dc5b5.resolve()) != $d9ccaaa112bb6e7e$var$promiseTag || $c6mom && $d9ccaaa112bb6e7e$var$getTag(new $c6mom) != $d9ccaaa112bb6e7e$var$setTag || $liOEB && $d9ccaaa112bb6e7e$var$getTag(new $liOEB) != $d9ccaaa112bb6e7e$var$weakMapTag) $d9ccaaa112bb6e7e$var$getTag = function(value) {
    var result = $Yvcvv(value), Ctor = result == $d9ccaaa112bb6e7e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $jdev5(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $d9ccaaa112bb6e7e$var$dataViewCtorString:
            return $d9ccaaa112bb6e7e$var$dataViewTag;
        case $d9ccaaa112bb6e7e$var$mapCtorString:
            return $d9ccaaa112bb6e7e$var$mapTag;
        case $d9ccaaa112bb6e7e$var$promiseCtorString:
            return $d9ccaaa112bb6e7e$var$promiseTag;
        case $d9ccaaa112bb6e7e$var$setCtorString:
            return $d9ccaaa112bb6e7e$var$setTag;
        case $d9ccaaa112bb6e7e$var$weakMapCtorString:
            return $d9ccaaa112bb6e7e$var$weakMapTag;
    }
    return result;
};
module.exports = $d9ccaaa112bb6e7e$var$getTag;

});
parcelRegister("38RsQ", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $249b9757c648f5e7$var$DataView = $7oqXh($fbsQc, "DataView");
module.exports = $249b9757c648f5e7$var$DataView;

});

parcelRegister("dc5b5", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $99b069919fabd61d$var$Promise = $7oqXh($fbsQc, "Promise");
module.exports = $99b069919fabd61d$var$Promise;

});

parcelRegister("c6mom", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $8cf76a24c320ca4c$var$Set = $7oqXh($fbsQc, "Set");
module.exports = $8cf76a24c320ca4c$var$Set;

});

parcelRegister("liOEB", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $f82292379ae88733$var$WeakMap = $7oqXh($fbsQc, "WeakMap");
module.exports = $f82292379ae88733$var$WeakMap;

});


parcelRegister("4vcv5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3473c0fe0e2991b1$var$_react = $3473c0fe0e2991b1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3473c0fe0e2991b1$var$_baseNew = $3473c0fe0e2991b1$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $3473c0fe0e2991b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3473c0fe0e2991b1$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $3473c0fe0e2991b1$var$_react.default.createElement($3473c0fe0e2991b1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$3473c0fe0e2991b1$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $3473c0fe0e2991b1$var$_default = module.exports.default = $3473c0fe0e2991b1$var$ChevronDownIcon;

});

parcelRegister("9HFEq", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return (parcelRequire("dbhgV")).Card; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("dbhgV")).Card; });

var $dbhgV = parcelRequire("dbhgV");

});
parcelRegister("dbhgV", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $1d73d5771cc6d344$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $ix9oc = parcelRequire("ix9oc");
const $1d73d5771cc6d344$var$containerStyles = null;
const $1d73d5771cc6d344$var$contentBlockStyles = null;
const $1d73d5771cc6d344$var$barStyles = null; /**
                         * @deprecated - Please use @/libraries/design/components/card instead
                         */ 
const $1d73d5771cc6d344$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "#ffffff";
    const cardBackTextColor = textColor !== null && textColor !== void 0 ? textColor : "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor !== null && iconColor !== void 0 ? iconColor : "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $43MIc.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $43MIc.default)(cardBackTextColor),
            "--_8vvi5m": (0, $43MIc.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $esG4f.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


parcelRegister("f0Hih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dhmEV")).default; });

var $dhmEV = parcelRequire("dhmEV");

});

parcelRegister("ayjUl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aec85a235a3439c$var$_react = $7aec85a235a3439c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7aec85a235a3439c$var$_baseNew = $7aec85a235a3439c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7aec85a235a3439c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aec85a235a3439c$var$AddIcon = (props)=>/*#__PURE__*/ $7aec85a235a3439c$var$_react.default.createElement($7aec85a235a3439c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$7aec85a235a3439c$var$AddIcon.displayName = "AddIcon";
var $7aec85a235a3439c$var$_default = module.exports.default = $7aec85a235a3439c$var$AddIcon;

});

parcelRegister("h6aNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c72b60579b631d81$var$_react = $c72b60579b631d81$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $c72b60579b631d81$var$_chevronDown = $c72b60579b631d81$var$_interopRequireDefault((parcelRequire("4vcv5")));
function $c72b60579b631d81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c72b60579b631d81$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c72b60579b631d81$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $c72b60579b631d81$var$_chevronDown.default
    }));
$c72b60579b631d81$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $c72b60579b631d81$var$_default = module.exports.default = $c72b60579b631d81$var$ChevronDownIcon;

});

parcelRegister("gLhLj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c33ed04b07fb9f0d$var$_react = $c33ed04b07fb9f0d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c33ed04b07fb9f0d$var$_baseNew = $c33ed04b07fb9f0d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c33ed04b07fb9f0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c33ed04b07fb9f0d$var$LinkIcon = (props)=>/*#__PURE__*/ $c33ed04b07fb9f0d$var$_react.default.createElement($c33ed04b07fb9f0d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$c33ed04b07fb9f0d$var$LinkIcon.displayName = "LinkIcon";
var $c33ed04b07fb9f0d$var$_default = module.exports.default = $c33ed04b07fb9f0d$var$LinkIcon;

});

parcelRegister("58T21", function(module, exports) {
"use strict";

module.exports = (parcelRequire("f7QOs"));

});
parcelRegister("f7QOs", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b0307a01c97f3576$export$c4744153514ff05d; }, function (v) { return $b0307a01c97f3576$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b0307a01c97f3576$export$3e506c1ccc9cc1a7; }, function (v) { return $b0307a01c97f3576$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b0307a01c97f3576$export$e26fe2ed2fa76875; }, function (v) { return $b0307a01c97f3576$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b0307a01c97f3576$export$502329bbf4b505b1; }, function (v) { return $b0307a01c97f3576$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b0307a01c97f3576$export$6e3807111c4874c4; }, function (v) { return $b0307a01c97f3576$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b0307a01c97f3576$export$c27134553091fb3a; }, function (v) { return $b0307a01c97f3576$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b0307a01c97f3576$export$33ee1acdc04fd2a2; }, function (v) { return $b0307a01c97f3576$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b0307a01c97f3576$export$b00a404bbd5edef2; }, function (v) { return $b0307a01c97f3576$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b0307a01c97f3576$export$d66a1c1c77bd778b; }, function (v) { return $b0307a01c97f3576$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b0307a01c97f3576$export$d3dfb8e4810cb555; }, function (v) { return $b0307a01c97f3576$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b0307a01c97f3576$export$72fdf0e06517287b; }, function (v) { return $b0307a01c97f3576$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b0307a01c97f3576$export$816d2913ae6b83b1; }, function (v) { return $b0307a01c97f3576$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b0307a01c97f3576$export$61bcfe829111a1d0; }, function (v) { return $b0307a01c97f3576$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b0307a01c97f3576$export$7ee8c9beb337bc3f; }, function (v) { return $b0307a01c97f3576$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b0307a01c97f3576$export$b5836b71941fa3ed; }, function (v) { return $b0307a01c97f3576$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b0307a01c97f3576$export$cf845f2c119da08a; }, function (v) { return $b0307a01c97f3576$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0307a01c97f3576$export$c4744153514ff05d;
var $b0307a01c97f3576$export$3e506c1ccc9cc1a7;
var $b0307a01c97f3576$export$e26fe2ed2fa76875;
var $b0307a01c97f3576$export$502329bbf4b505b1;
var $b0307a01c97f3576$export$6e3807111c4874c4;
var $b0307a01c97f3576$export$c27134553091fb3a;
var $b0307a01c97f3576$export$33ee1acdc04fd2a2;
var $b0307a01c97f3576$export$b00a404bbd5edef2;
var $b0307a01c97f3576$export$d66a1c1c77bd778b;
var $b0307a01c97f3576$export$d3dfb8e4810cb555;
var $b0307a01c97f3576$export$72fdf0e06517287b;
var $b0307a01c97f3576$export$816d2913ae6b83b1;
var $b0307a01c97f3576$export$61bcfe829111a1d0;
var $b0307a01c97f3576$export$7ee8c9beb337bc3f;
var $b0307a01c97f3576$export$b5836b71941fa3ed;
var $b0307a01c97f3576$export$cf845f2c119da08a;
"use strict";
function $b0307a01c97f3576$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $b0307a01c97f3576$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $b0307a01c97f3576$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $b0307a01c97f3576$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $b0307a01c97f3576$var$compare(left, last)) rightIndex < length && 0 > $b0307a01c97f3576$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $b0307a01c97f3576$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $b0307a01c97f3576$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$b0307a01c97f3576$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b0307a01c97f3576$var$localPerformance = performance;
    $b0307a01c97f3576$export$c4744153514ff05d = function() {
        return $b0307a01c97f3576$var$localPerformance.now();
    };
} else {
    var $b0307a01c97f3576$var$localDate = Date, $b0307a01c97f3576$var$initialTime = $b0307a01c97f3576$var$localDate.now();
    $b0307a01c97f3576$export$c4744153514ff05d = function() {
        return $b0307a01c97f3576$var$localDate.now() - $b0307a01c97f3576$var$initialTime;
    };
}
var $b0307a01c97f3576$var$taskQueue = [], $b0307a01c97f3576$var$timerQueue = [], $b0307a01c97f3576$var$taskIdCounter = 1, $b0307a01c97f3576$var$currentTask = null, $b0307a01c97f3576$var$currentPriorityLevel = 3, $b0307a01c97f3576$var$isPerformingWork = !1, $b0307a01c97f3576$var$isHostCallbackScheduled = !1, $b0307a01c97f3576$var$isHostTimeoutScheduled = !1, $b0307a01c97f3576$var$needsPaint = !1, $b0307a01c97f3576$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $b0307a01c97f3576$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $b0307a01c97f3576$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $b0307a01c97f3576$var$advanceTimers(currentTime) {
    for(var timer = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue); null !== timer;){
        if (null === timer.callback) $b0307a01c97f3576$var$pop($b0307a01c97f3576$var$timerQueue);
        else if (timer.startTime <= currentTime) $b0307a01c97f3576$var$pop($b0307a01c97f3576$var$timerQueue), timer.sortIndex = timer.expirationTime, $b0307a01c97f3576$var$push($b0307a01c97f3576$var$taskQueue, timer);
        else break;
        timer = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue);
    }
}
function $b0307a01c97f3576$var$handleTimeout(currentTime) {
    $b0307a01c97f3576$var$isHostTimeoutScheduled = !1;
    $b0307a01c97f3576$var$advanceTimers(currentTime);
    if (!$b0307a01c97f3576$var$isHostCallbackScheduled) {
        if (null !== $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue)) $b0307a01c97f3576$var$isHostCallbackScheduled = !0, $b0307a01c97f3576$var$isMessageLoopRunning || ($b0307a01c97f3576$var$isMessageLoopRunning = !0, $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue);
            null !== firstTimer && $b0307a01c97f3576$var$requestHostTimeout($b0307a01c97f3576$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $b0307a01c97f3576$var$isMessageLoopRunning = !1, $b0307a01c97f3576$var$taskTimeoutID = -1, $b0307a01c97f3576$var$frameInterval = 5, $b0307a01c97f3576$var$startTime = -1;
function $b0307a01c97f3576$var$shouldYieldToHost() {
    return $b0307a01c97f3576$var$needsPaint ? !0 : $b0307a01c97f3576$export$c4744153514ff05d() - $b0307a01c97f3576$var$startTime < $b0307a01c97f3576$var$frameInterval ? !1 : !0;
}
function $b0307a01c97f3576$var$performWorkUntilDeadline() {
    $b0307a01c97f3576$var$needsPaint = !1;
    if ($b0307a01c97f3576$var$isMessageLoopRunning) {
        var currentTime = $b0307a01c97f3576$export$c4744153514ff05d();
        $b0307a01c97f3576$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $b0307a01c97f3576$var$isHostCallbackScheduled = !1;
                $b0307a01c97f3576$var$isHostTimeoutScheduled && ($b0307a01c97f3576$var$isHostTimeoutScheduled = !1, $b0307a01c97f3576$var$localClearTimeout($b0307a01c97f3576$var$taskTimeoutID), $b0307a01c97f3576$var$taskTimeoutID = -1);
                $b0307a01c97f3576$var$isPerformingWork = !0;
                var previousPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
                try {
                    b: {
                        $b0307a01c97f3576$var$advanceTimers(currentTime);
                        for($b0307a01c97f3576$var$currentTask = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue); null !== $b0307a01c97f3576$var$currentTask && !($b0307a01c97f3576$var$currentTask.expirationTime > currentTime && $b0307a01c97f3576$var$shouldYieldToHost());){
                            var callback = $b0307a01c97f3576$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $b0307a01c97f3576$var$currentTask.callback = null;
                                $b0307a01c97f3576$var$currentPriorityLevel = $b0307a01c97f3576$var$currentTask.priorityLevel;
                                var continuationCallback = callback($b0307a01c97f3576$var$currentTask.expirationTime <= currentTime);
                                currentTime = $b0307a01c97f3576$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $b0307a01c97f3576$var$currentTask.callback = continuationCallback;
                                    $b0307a01c97f3576$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $b0307a01c97f3576$var$currentTask === $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue) && $b0307a01c97f3576$var$pop($b0307a01c97f3576$var$taskQueue);
                                $b0307a01c97f3576$var$advanceTimers(currentTime);
                            } else $b0307a01c97f3576$var$pop($b0307a01c97f3576$var$taskQueue);
                            $b0307a01c97f3576$var$currentTask = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue);
                        }
                        if (null !== $b0307a01c97f3576$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue);
                            null !== firstTimer && $b0307a01c97f3576$var$requestHostTimeout($b0307a01c97f3576$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $b0307a01c97f3576$var$currentTask = null, $b0307a01c97f3576$var$currentPriorityLevel = previousPriorityLevel, $b0307a01c97f3576$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline() : $b0307a01c97f3576$var$isMessageLoopRunning = !1;
        }
    }
}
var $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $b0307a01c97f3576$var$localSetImmediate) $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline = function() {
    $b0307a01c97f3576$var$localSetImmediate($b0307a01c97f3576$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b0307a01c97f3576$var$channel = new MessageChannel(), $b0307a01c97f3576$var$port = $b0307a01c97f3576$var$channel.port2;
    $b0307a01c97f3576$var$channel.port1.onmessage = $b0307a01c97f3576$var$performWorkUntilDeadline;
    $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline = function() {
        $b0307a01c97f3576$var$port.postMessage(null);
    };
} else $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline = function() {
    $b0307a01c97f3576$var$localSetTimeout($b0307a01c97f3576$var$performWorkUntilDeadline, 0);
};
function $b0307a01c97f3576$var$requestHostTimeout(callback, ms) {
    $b0307a01c97f3576$var$taskTimeoutID = $b0307a01c97f3576$var$localSetTimeout(function() {
        callback($b0307a01c97f3576$export$c4744153514ff05d());
    }, ms);
}
$b0307a01c97f3576$export$3e506c1ccc9cc1a7 = 5;
$b0307a01c97f3576$export$e26fe2ed2fa76875 = 1;
$b0307a01c97f3576$export$502329bbf4b505b1 = 4;
$b0307a01c97f3576$export$6e3807111c4874c4 = 3;
$b0307a01c97f3576$export$c27134553091fb3a = null;
$b0307a01c97f3576$export$33ee1acdc04fd2a2 = 2;
$b0307a01c97f3576$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$b0307a01c97f3576$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b0307a01c97f3576$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$b0307a01c97f3576$export$d3dfb8e4810cb555 = function() {
    return $b0307a01c97f3576$var$currentPriorityLevel;
};
$b0307a01c97f3576$export$72fdf0e06517287b = function(eventHandler) {
    switch($b0307a01c97f3576$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
    $b0307a01c97f3576$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $b0307a01c97f3576$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$b0307a01c97f3576$export$816d2913ae6b83b1 = function() {
    $b0307a01c97f3576$var$needsPaint = !0;
};
$b0307a01c97f3576$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
    $b0307a01c97f3576$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $b0307a01c97f3576$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$b0307a01c97f3576$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $b0307a01c97f3576$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $b0307a01c97f3576$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $b0307a01c97f3576$var$push($b0307a01c97f3576$var$timerQueue, priorityLevel), null === $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue) && priorityLevel === $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue) && ($b0307a01c97f3576$var$isHostTimeoutScheduled ? ($b0307a01c97f3576$var$localClearTimeout($b0307a01c97f3576$var$taskTimeoutID), $b0307a01c97f3576$var$taskTimeoutID = -1) : $b0307a01c97f3576$var$isHostTimeoutScheduled = !0, $b0307a01c97f3576$var$requestHostTimeout($b0307a01c97f3576$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $b0307a01c97f3576$var$push($b0307a01c97f3576$var$taskQueue, priorityLevel), $b0307a01c97f3576$var$isHostCallbackScheduled || $b0307a01c97f3576$var$isPerformingWork || ($b0307a01c97f3576$var$isHostCallbackScheduled = !0, $b0307a01c97f3576$var$isMessageLoopRunning || ($b0307a01c97f3576$var$isMessageLoopRunning = !0, $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$b0307a01c97f3576$export$b5836b71941fa3ed = $b0307a01c97f3576$var$shouldYieldToHost;
$b0307a01c97f3576$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
        $b0307a01c97f3576$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $b0307a01c97f3576$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("ddmnE", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7N4Fa"));

});
parcelRegister("7N4Fa", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $5ac0b9fa938ca169$export$306c0aa65ff9ec16; }, function (v) { return $5ac0b9fa938ca169$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ac0b9fa938ca169$export$306c0aa65ff9ec16;
"use strict";

var $iSvIT = parcelRequire("iSvIT");
function $5ac0b9fa938ca169$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5ac0b9fa938ca169$var$k = "function" === typeof Object.is ? Object.is : $5ac0b9fa938ca169$var$h, $5ac0b9fa938ca169$var$l = $iSvIT.useState, $5ac0b9fa938ca169$var$m = $iSvIT.useEffect, $5ac0b9fa938ca169$var$n = $iSvIT.useLayoutEffect, $5ac0b9fa938ca169$var$p = $iSvIT.useDebugValue;
function $5ac0b9fa938ca169$var$q(a, b) {
    var d = b(), f = $5ac0b9fa938ca169$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $5ac0b9fa938ca169$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $5ac0b9fa938ca169$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $5ac0b9fa938ca169$var$m(function() {
        $5ac0b9fa938ca169$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $5ac0b9fa938ca169$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $5ac0b9fa938ca169$var$p(d);
    return d;
}
function $5ac0b9fa938ca169$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$5ac0b9fa938ca169$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $5ac0b9fa938ca169$var$t(a, b) {
    return b();
}
var $5ac0b9fa938ca169$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $5ac0b9fa938ca169$var$t : $5ac0b9fa938ca169$var$q;
$5ac0b9fa938ca169$export$306c0aa65ff9ec16 = void 0 !== $iSvIT.useSyncExternalStore ? $iSvIT.useSyncExternalStore : $5ac0b9fa938ca169$var$u;

});


parcelRegister("isSvf", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return (parcelRequire("lxS8L")).Video; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("lxS8L")).Video; });

var $lxS8L = parcelRequire("lxS8L");

});
parcelRegister("lxS8L", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $ed253e67f972fd3a$export$ae01dedf5c052bb; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $ed253e67f972fd3a$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $7Knp0._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $ed253e67f972fd3a$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $iSvIT.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $ed253e67f972fd3a$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});


parcelRegister("fovuc", function(module, exports) {

$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("5ZfUA")).BannerAlert; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

var $5ZfUA = parcelRequire("5ZfUA");

});
parcelRegister("5ZfUA", function(module, exports) {

$parcel$export(module.exports, "BannerAlert", function () { return $a7a242474da496d8$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $a7a242474da496d8$var$containerStyles = null;
const $a7a242474da496d8$var$contentStyles = null;
const $a7a242474da496d8$var$closeIconStyles = null; /**
                               * @deprecated - Please use @/libraries/design/components/banner-alert instead
                               */ 
const $a7a242474da496d8$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $f6qj2.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    (0, $iSvIT.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $esG4f.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $esG4f.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $esG4f.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});


parcelRegister("aq08R", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $795c7147db52ce07$export$f04a61298a47a40f; });

var $2p5Xr = parcelRequire("2p5Xr");

var $5ScFE = parcelRequire("5ScFE");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $92BHb = parcelRequire("92BHb");

var $7R2ca = parcelRequire("7R2ca");

var $iVdhe = parcelRequire("iVdhe");
function $795c7147db52ce07$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $795c7147db52ce07$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $795c7147db52ce07$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $5ScFE.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $795c7147db52ce07$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $795c7147db52ce07$var$iconStyles = (0, $2ZUkg.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $795c7147db52ce07$var$_objectSpread($795c7147db52ce07$var$_objectSpread({}, (0, $iVdhe.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $795c7147db52ce07$var$baseHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $795c7147db52ce07$var$primaryEqualsSecondaryHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $795c7147db52ce07$var$secondaryTransparentHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $795c7147db52ce07$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $2ZUkg.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $iVdhe.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $92BHb.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $2ZUkg.jsx)("span", (0, $2p5Xr.default)({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $7R2ca.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $795c7147db52ce07$var$iconStyles,
            $795c7147db52ce07$var$baseHcmStyles,
            primaryColor === secondaryColor && $795c7147db52ce07$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $795c7147db52ce07$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $2ZUkg.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $795c7147db52ce07$export$2e2bcd8739ae039 = $795c7147db52ce07$export$f04a61298a47a40f;

});
parcelRegister("2p5Xr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c0289aaad73c457$export$2e2bcd8739ae039; });
function $1c0289aaad73c457$export$2e2bcd8739ae039() {
    return $1c0289aaad73c457$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1c0289aaad73c457$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("5ScFE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $446bd3124bfb46c2$export$2e2bcd8739ae039; });

var $jltev = parcelRequire("jltev");
function $446bd3124bfb46c2$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jltev.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("jltev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e156a78f7e3181fe$export$2e2bcd8739ae039; });

var $5x5Bg = parcelRequire("5x5Bg");

var $drI6V = parcelRequire("drI6V");
function $e156a78f7e3181fe$export$2e2bcd8739ae039(t) {
    var i = (0, $drI6V.default)(t, "string");
    return "symbol" == (0, $5x5Bg.default)(i) ? i : i + "";
}

});
parcelRegister("5x5Bg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $407460e2a6ec6969$export$2e2bcd8739ae039; });
function $407460e2a6ec6969$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $407460e2a6ec6969$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $407460e2a6ec6969$export$2e2bcd8739ae039(o);
}

});

parcelRegister("drI6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ca0036d50b30d3c$export$2e2bcd8739ae039; });

var $5x5Bg = parcelRequire("5x5Bg");
function $9ca0036d50b30d3c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5x5Bg.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5x5Bg.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("92BHb", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $69518a8212815c20$export$7692396083754928; });

var $85ijK = parcelRequire("85ijK");
// Create default global light theme
var $69518a8212815c20$var$_createTheme = (0, $85ijK.createTheme)(function() {
    return {
        mode: "light"
    };
}), $69518a8212815c20$var$Provider = $69518a8212815c20$var$_createTheme.Provider, $69518a8212815c20$var$Consumer = $69518a8212815c20$var$_createTheme.Consumer, $69518a8212815c20$export$7692396083754928 = $69518a8212815c20$var$_createTheme.useTheme;
var $69518a8212815c20$export$2e2bcd8739ae039 = {
    Provider: $69518a8212815c20$var$Provider,
    Consumer: $69518a8212815c20$var$Consumer
};

});
parcelRegister("85ijK", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $5e2cffcff8166eb4$export$25d302a5b900a763; });

var $FOVCo = parcelRequire("FOVCo");

var $iSvIT = parcelRequire("iSvIT");
var $5e2cffcff8166eb4$var$_excluded = [
    "children"
];
function $5e2cffcff8166eb4$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $FOVCo.default)(props, $5e2cffcff8166eb4$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("FOVCo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07db55c12b80e284$export$2e2bcd8739ae039; });

var $eRAvS = parcelRequire("eRAvS");
function $07db55c12b80e284$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $eRAvS.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("eRAvS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad2256b344d80bcd$export$2e2bcd8739ae039; });
function $ad2256b344d80bcd$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("7R2ca", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $5b7f2f8e5b7c88e2$export$18cb9425622d4e06; });
var $5b7f2f8e5b7c88e2$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $5b7f2f8e5b7c88e2$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $5b7f2f8e5b7c88e2$var$themedBackground[mode];
};

});

parcelRegister("iVdhe", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $dc67d9642d22a737$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $dc67d9642d22a737$export$3eb7d6130acfda37; });

var $G3TfW = parcelRequire("G3TfW");

var $2ZUkg = parcelRequire("2ZUkg");
var $dc67d9642d22a737$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $dc67d9642d22a737$var$smallStyles = (0, $2ZUkg.css)((0, $G3TfW.dimensions).small);
var $dc67d9642d22a737$var$mediumStyles = (0, $2ZUkg.css)((0, $G3TfW.dimensions).medium);
var $dc67d9642d22a737$var$largeStyles = (0, $2ZUkg.css)((0, $G3TfW.dimensions).large);
var $dc67d9642d22a737$var$xlargeStyles = (0, $2ZUkg.css)((0, $G3TfW.dimensions).xlarge);
var $dc67d9642d22a737$export$ef0ad74202575b64 = {
    small: $dc67d9642d22a737$var$smallStyles,
    medium: $dc67d9642d22a737$var$mediumStyles,
    large: $dc67d9642d22a737$var$largeStyles,
    xlarge: $dc67d9642d22a737$var$xlargeStyles
};
var $dc67d9642d22a737$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $G3TfW.dimensions)[size];
    return undefined;
};

});
parcelRegister("G3TfW", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $07e6f0e0864a7d74$export$62ad7b0c781000e9; });
var $07e6f0e0864a7d74$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $07e6f0e0864a7d74$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $07e6f0e0864a7d74$export$62ad7b0c781000e9 = {
    small: {
        width: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.small,
        height: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.medium,
        height: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.large,
        height: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.xlarge,
        height: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("h6XJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c751561ab60544bd$var$_react = $c751561ab60544bd$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aq08R = parcelRequire("aq08R");
function $c751561ab60544bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c751561ab60544bd$var$Story16Icon = (props)=>/*#__PURE__*/ $c751561ab60544bd$var$_react.default.createElement($aq08R.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 11l-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426L8 11zm0-2.371l2 1.274V5H6v4.902L8 8.63z"/></svg>`
    }, props, {
        size: "small"
    }));
$c751561ab60544bd$var$Story16Icon.displayName = "Story16Icon";
var $c751561ab60544bd$var$_default = $c751561ab60544bd$var$Story16Icon;
module.exports.default = $c751561ab60544bd$var$_default;

});

parcelRegister("ixaDK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7e38ffb7694e997$var$_react = $d7e38ffb7694e997$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d7e38ffb7694e997$var$_refresh = $d7e38ffb7694e997$var$_interopRequireDefault((parcelRequire("5sfxx")));
function $d7e38ffb7694e997$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d7e38ffb7694e997$var$RefreshIcon = (props)=>/*#__PURE__*/ $d7e38ffb7694e997$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $d7e38ffb7694e997$var$_refresh.default
    }));
$d7e38ffb7694e997$var$RefreshIcon.displayName = "RefreshIcon";
var $d7e38ffb7694e997$var$_default = module.exports.default = $d7e38ffb7694e997$var$RefreshIcon;

});
parcelRegister("5sfxx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f8b9f2e6d41a4e8$var$_react = $3f8b9f2e6d41a4e8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3f8b9f2e6d41a4e8$var$_baseNew = $3f8b9f2e6d41a4e8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $3f8b9f2e6d41a4e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f8b9f2e6d41a4e8$var$RefreshIcon = (props)=>/*#__PURE__*/ $3f8b9f2e6d41a4e8$var$_react.default.createElement($3f8b9f2e6d41a4e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$3f8b9f2e6d41a4e8$var$RefreshIcon.displayName = "RefreshIcon";
var $3f8b9f2e6d41a4e8$var$_default = module.exports.default = $3f8b9f2e6d41a4e8$var$RefreshIcon;

});


parcelRegister("3mYuF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("308f7"));

});
parcelRegister("308f7", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $22f7c404d928fa4e$export$bf730a2d8bf68b42; }, function (v) { return $22f7c404d928fa4e$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $22f7c404d928fa4e$export$bf730a2d8bf68b42;
"use strict";

var $iSvIT = parcelRequire("iSvIT");

var $ddmnE = parcelRequire("ddmnE");
function $22f7c404d928fa4e$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $22f7c404d928fa4e$var$q = "function" === typeof Object.is ? Object.is : $22f7c404d928fa4e$var$p, $22f7c404d928fa4e$var$r = $ddmnE.useSyncExternalStore, $22f7c404d928fa4e$var$t = $iSvIT.useRef, $22f7c404d928fa4e$var$u = $iSvIT.useEffect, $22f7c404d928fa4e$var$v = $iSvIT.useMemo, $22f7c404d928fa4e$var$w = $iSvIT.useDebugValue;
$22f7c404d928fa4e$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $22f7c404d928fa4e$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $22f7c404d928fa4e$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($22f7c404d928fa4e$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $22f7c404d928fa4e$var$r(a, c[0], c[1]);
    $22f7c404d928fa4e$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $22f7c404d928fa4e$var$w(d);
    return d;
};

});


parcelRegister("6k5Ux", function(module, exports) {

$parcel$export(module.exports, "CloseModalButton", function () { return $b6c7a5686eb9158d$export$33330c88045ecd2e; });
/* close-modal-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f448m = parcelRequire("f448m");

var $lyYco = parcelRequire("lyYco");
const $b6c7a5686eb9158d$var$closeModalButtonStyles = null;
const $b6c7a5686eb9158d$export$33330c88045ecd2e = ({ forwardRef: forwardRef, onCloseClick: onCloseClick, styleOverrides: styleOverrides })=>{
    const [messages] = (0, $lyYco.useMessages)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        "data-testid": "closeModalBtn",
        "aria-label": messages.createIssueModalCloseBtn,
        style: styleOverrides,
        id: "createIssueModalCloseBtn",
        onClick: onCloseClick,
        ref: forwardRef,
        className: (0, $esG4f.default)([
            "_1bsb1ul9 _4t3i1ul9 _bfhk1j28 _19itglyw _1e0c1txw _1bah1h6o _4cvr1h6o _2rko1sit _80omtlke _v564fnf5 _vbqb1lg7 _jomr1f0r _irr31f0r"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f448m))), {
            label: "",
            size: "medium"
        })
    });
};

});
parcelRegister("lyYco", function(module, exports) {

$parcel$export(module.exports, "useMessages", function () { return $84c26da1c748a082$export$4d17e2d9c5348842; });
$parcel$export(module.exports, "useInteractiveBoardStore", function () { return $84c26da1c748a082$export$1953ec6382166e6d; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $4ejMU = parcelRequire("4ejMU");
var $ij7wO = parcelRequire("ij7wO");

var $ilpFV = parcelRequire("ilpFV");

var $575p2 = parcelRequire("575p2");
const $84c26da1c748a082$var$initialState = {
    step: (0, $575p2.Steps).CREATE_FIRST_STORY,
    isCreateButtonFocused: false,
    isDemoComplete: false,
    isTicketModalOpen: false,
    isDemoCompleteModalOpen: false,
    isDemoMessageVisible: true,
    todoCol: [],
    inProgressCol: [
        {
            id: "inProg1",
            summary: (0, $ilpFV.messages).inProgStaticLabel1,
            issueType: (0, $575p2.IssueTypeName).STORY,
            epicName: (0, $575p2.EpicName).FEATURES,
            assignee: (0, $575p2.Assignee).JANE,
            priority: (0, $575p2.Priority).BLOCKER
        },
        {
            id: "inProg2",
            summary: (0, $ilpFV.messages).inProgStaticLabel2,
            issueType: (0, $575p2.IssueTypeName).STORY,
            epicName: (0, $575p2.EpicName).FEATURES,
            assignee: (0, $575p2.Assignee).BLAKE,
            priority: (0, $575p2.Priority).HIGH
        }
    ],
    doneCol: [
        {
            id: "done1",
            summary: (0, $ilpFV.messages).doneStaticLabel1,
            issueType: (0, $575p2.IssueTypeName).BUG,
            epicName: (0, $575p2.EpicName).FEATURES,
            assignee: (0, $575p2.Assignee).ALVIN,
            priority: (0, $575p2.Priority).MINOR
        },
        {
            id: "done2",
            summary: (0, $ilpFV.messages).doneStaticLabel2,
            issueType: (0, $575p2.IssueTypeName).TASK,
            epicName: (0, $575p2.EpicName).FEATURES,
            assignee: (0, $575p2.Assignee).JANE,
            priority: (0, $575p2.Priority).CRITICAL
        }
    ],
    messages: (0, $ilpFV.messages),
    animateCardExit: false
};
const $84c26da1c748a082$var$actions = {
    completeDemo: ()=>({ setState: setState })=>{
            setState({
                isDemoComplete: true,
                isDemoMessageVisible: false,
                step: undefined
            });
        },
    createIssue: (jiraIssueData)=>({ setState: setState, getState: getState })=>{
            const { todoCol: todoCol } = getState();
            const todoColAppend = todoCol.concat([
                jiraIssueData
            ]);
            setState({
                todoCol: todoColAppend
            });
        },
    nextDemoStep: ()=>({ setState: setState, getState: getState })=>{
            const { step: step } = getState();
            if (step === (0, $575p2.stepsLength) - 1) {
                console.error("Error: cannot goto next message, currently on final message");
                return;
            }
            setState({
                step: step + 1,
                isDemoMessageVisible: true,
                animateCardExit: false
            });
        },
    prevDemoStep: ()=>({ setState: setState, getState: getState })=>{
            const { step: step } = getState();
            if (step === 0) {
                console.error("Error: cannot goto prev message, currently on first message");
                return;
            }
            setState({
                step: step - 1,
                isDemoMessageVisible: true
            });
        },
    restartDemo: ()=>({ setState: setState, getState: getState })=>{
            const { messages: messages, inProgressCol: inProgressCol, doneCol: doneCol } = getState();
            setState((0, $6iHNw._)((0, $7Knp0._)({}, $84c26da1c748a082$var$initialState), {
                messages: messages,
                inProgressCol: inProgressCol,
                doneCol: doneCol,
                isCreateButtonFocused: true
            }));
        },
    resetIncompleteDemo: ()=>({ setState: setState })=>{
            setState({
                step: (0, $575p2.Steps).CREATE_FIRST_STORY,
                isDemoMessageVisible: true
            });
        },
    setTodoCol: (colInfo)=>({ setState: setState })=>{
            setState({
                todoCol: colInfo
            });
        },
    setDoneCol: (colInfo)=>({ setState: setState })=>{
            setState({
                doneCol: colInfo
            });
        },
    setInProgressCol: (colInfo)=>({ setState: setState })=>{
            setState({
                inProgressCol: colInfo
            });
        },
    setDemoStep: (step)=>({ setState: setState })=>{
            setState({
                step: step
            });
        },
    toggleCompleteDemoModalOpen: ()=>({ setState: setState, getState: getState })=>{
            const { isDemoCompleteModalOpen: prevStateIsModalOpen } = getState();
            setState({
                isCreateButtonFocused: prevStateIsModalOpen,
                isDemoCompleteModalOpen: !prevStateIsModalOpen
            });
        },
    setSpotlightVisibility: (visible)=>({ setState: setState })=>{
            setState({
                isDemoMessageVisible: visible
            });
        },
    toggleTicketModalOpen: ()=>({ setState: setState, getState: getState })=>{
            const { isTicketModalOpen: prevStateIsModalOpen } = getState();
            setState({
                isCreateButtonFocused: prevStateIsModalOpen,
                isTicketModalOpen: !prevStateIsModalOpen
            });
        },
    transitionCard: ()=>({ setState: setState })=>{
            setState({
                animateCardExit: true
            });
        }
};
const $84c26da1c748a082$var$InteractiveBoardStore = (0, $ij7wO.createStore)({
    initialState: $84c26da1c748a082$var$initialState,
    actions: $84c26da1c748a082$var$actions,
    name: "jsw-interactive-board-store"
});
const $84c26da1c748a082$var$getMessages = (state)=>state.messages;
const $84c26da1c748a082$export$4d17e2d9c5348842 = (0, $4ejMU.createHook)($84c26da1c748a082$var$InteractiveBoardStore, {
    selector: $84c26da1c748a082$var$getMessages
});
const $84c26da1c748a082$export$1953ec6382166e6d = (0, $4ejMU.createHook)($84c26da1c748a082$var$InteractiveBoardStore);

});
parcelRegister("ilpFV", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $cbdd78813a066596$export$defe85febe8b728c; });
const $cbdd78813a066596$export$defe85febe8b728c = {
    createIssueModalHeader: "Create issue",
    createIssueModalInput1Label: "Project",
    createIssueModalInput2Label: "Issue type",
    createIssueModalInput3Label: "Summary",
    createIssueModalInput3Placeholder: "Ex: Create a requirements doc",
    createIssueModalInput4Label: "Issue description",
    createIssueModalInput4Placeholder: "Add notes: \nWrite details here like receive final prototypes from design. \n \nAdd tasks: \nWrite necessary tasks to complete your project here.",
    createIssueModalInput5Label: "Priority",
    createIssueModalInput6Label: "Epic link",
    createIssueModalInput7Label: "Assignee",
    createIssueModalInput8Label: "Due date",
    createIssueModalProjectOption1: "Team Rocket",
    createIssueModalProjectAssetLabel1: "project team rocket",
    createIssueModalIssueTypeOption1: "Task",
    createIssueModalIssueTypeAssetLabel1: "Issue type: Task",
    createIssueModalIssueTypeOption2: "Story",
    createIssueModalIssueTypeAssetLabel2: "Issue type: Story",
    createIssueModalIssueTypeOption3: "Bug",
    createIssueModalIssueTypeAssetLabel3: "Issue type: Bug",
    createIssueModalAssigneeOption1: "Alvin",
    createIssueModalAssigneeAssetLabel1: "Assignee: Alvin",
    createIssueModalAssigneeOption2: "Jane",
    createIssueModalAssigneeAssetLabel2: "Assignee: Jane",
    createIssueModalAssigneeOption3: "Blake",
    createIssueModalAssigneeAssetLabel3: "Assignee: Blake",
    createIssueModalPriorityOption1: "High",
    createIssueModalPriorityAssetLabel1: "Priority: High",
    createIssueModalPriorityOption2: "Critical",
    createIssueModalPriorityAssetLabel2: "Priority: Critical",
    createIssueModalPriorityOption3: "Blocker",
    createIssueModalPriorityAssetLabel3: "Priority: Blocker",
    createIssueModalPriorityOption4: "Minor",
    createIssueModalPriorityAssetLabel4: "Priority: Minor",
    createIssueModalEpicLinkOption1: "Features",
    createIssueModalEpicLinkOption1Description: "APP-153",
    createIssueModalEpicLinkAssetLabel1: "Epic link: Features",
    createIssueModalEpicLinkOption2: "Analytics",
    createIssueModalEpicLinkOption2Description: "APP-154",
    createIssueModalEpicLinkAssetLabel2: "Epic link: Features",
    createIssueModalEpicLinkOption3: "Payments",
    createIssueModalEpicLinkOption3Description: "APP-155",
    createIssueModalEpicLinkAssetLabel3: "Epic link: Payments",
    createIssueModalSubmitBtn: "Create",
    createIssueModalCloseBtn: "Close modal",
    toDo: "To Do",
    inProgress: "In Progress",
    done: "Done",
    create: "Create",
    restartDemo: "Restart demo",
    avatarGroupAriaLabel: "Collection of user avatars showing team members",
    todoStaticLabel: "Design AI shopping suggestions for homepage",
    inProgStaticLabel1: "Create AI-generated shopping suggestions for homepage",
    inProgStaticLabel2: "Add advanced analytics tracking events",
    doneStaticLabel1: "Improve payment checkout time on mobile",
    doneStaticLabel2: "Define requirements to use new AI integrations",
    spotlightInitialCreateButtonHeading: "Let's set up your board",
    spotlightInitialCreateButtonDescription: "Kanban boards are great for project management. Select create to start tracking work that your team would like to do.",
    spotlightSelectIssueHeading: "Create an issue",
    spotlightSelectIssueDescription: "Issues are used to track work in Jira. Tasks, stories, and bugs are different types of issues. Select what type of issue you\u2019d like to create.",
    spotlightMoveIssueHeading: "Move your task to the board",
    spotlightMoveIssueDescription: `Now that you\u{2019}ve added all the info to your task. Select create to see your work on the \u{201C}To-do\u{201D} list.`,
    spotlightSummaryHeading: "Tell us about your work",
    spotlightSummaryDescription: "Summarize your to-do in a few words. It can be anything, like complete mobile app designs or developing a new feature.",
    spotlightAddDescriptionHeading: "Provide useful details",
    spotlightAddDescriptionDescription: "Add any important information about the work that\u2019s needed to move it forward.",
    spotlightSelectPriorityHeading: "Prioritize your task",
    spotlightSelectPriorityDescription: "Choose the importance of a task to change how it appears on the board. Select a level of priority to identify this task at a glance.",
    spotlightSelectEpicLinkHeading: "Connect work to larger projects",
    spotlightSelectEpicLinkDescription: "You can connect this issue to longer term projects. This will help your team plan accurately.",
    staticSpotlightHeading: "Expand your screen size to use this demo",
    successModalHeading: "Congrats, you\u2019ve made your first issue!",
    successModalDescription: "You\u2019ve taken the first step towards streamlined collaboration and task tracking. Get started for free using the project management template in Jira.",
    successModalCtaButton: "Get it free"
};

});

parcelRegister("575p2", function(module, exports) {

$parcel$export(module.exports, "Steps", function () { return $e073124ced5a2b69$export$fb587a27d5a722e7; });
$parcel$export(module.exports, "IssueTypeName", function () { return $e073124ced5a2b69$export$41bec0868bbe9664; });
$parcel$export(module.exports, "EpicName", function () { return $e073124ced5a2b69$export$82af5b919cf981f7; });
$parcel$export(module.exports, "Assignee", function () { return $e073124ced5a2b69$export$361f73eba39649ac; });
$parcel$export(module.exports, "Priority", function () { return $e073124ced5a2b69$export$300334f671c43555; });
$parcel$export(module.exports, "stepsLength", function () { return $e073124ced5a2b69$export$33096039fd990cf4; });
var $e073124ced5a2b69$export$fb587a27d5a722e7;
(function(Steps) {
    Steps[Steps["CREATE_FIRST_STORY"] = 0] = "CREATE_FIRST_STORY";
    Steps[Steps["SELECT_ISSUE_TYPE"] = 1] = "SELECT_ISSUE_TYPE";
    Steps[Steps["ADD_SUMMARY"] = 2] = "ADD_SUMMARY";
    Steps[Steps["ADD_DESCRIPTION"] = 3] = "ADD_DESCRIPTION";
    Steps[Steps["SELECT_PRIORITY"] = 4] = "SELECT_PRIORITY";
    Steps[Steps["SELECT_EPIC_LINK"] = 5] = "SELECT_EPIC_LINK";
    Steps[Steps["MOVE_ISSUE"] = 6] = "MOVE_ISSUE";
    Steps[Steps["PULSE_CARD"] = 7] = "PULSE_CARD";
})($e073124ced5a2b69$export$fb587a27d5a722e7 || ($e073124ced5a2b69$export$fb587a27d5a722e7 = {}));
var $e073124ced5a2b69$export$b6032183171af19f;
(function(Project) {
    Project["TeamRocket"] = "team-rocket";
})($e073124ced5a2b69$export$b6032183171af19f || ($e073124ced5a2b69$export$b6032183171af19f = {}));
var $e073124ced5a2b69$export$41bec0868bbe9664;
(function(IssueTypeName) {
    IssueTypeName["TASK"] = "task";
    IssueTypeName["STORY"] = "story";
    IssueTypeName["BUG"] = "bug";
})($e073124ced5a2b69$export$41bec0868bbe9664 || ($e073124ced5a2b69$export$41bec0868bbe9664 = {}));
var $e073124ced5a2b69$export$82af5b919cf981f7;
(function(EpicName) {
    EpicName["FEATURES"] = "features";
    EpicName["ANALYTICS"] = "analytics";
    EpicName["PAYMENTS"] = "payments";
})($e073124ced5a2b69$export$82af5b919cf981f7 || ($e073124ced5a2b69$export$82af5b919cf981f7 = {}));
var $e073124ced5a2b69$export$361f73eba39649ac;
(function(Assignee) {
    Assignee["ALVIN"] = "alvin";
    Assignee["JANE"] = "jane";
    Assignee["BLAKE"] = "blake";
})($e073124ced5a2b69$export$361f73eba39649ac || ($e073124ced5a2b69$export$361f73eba39649ac = {}));
var $e073124ced5a2b69$export$300334f671c43555;
(function(Priority) {
    Priority["HIGH"] = "high";
    Priority["CRITICAL"] = "critical";
    Priority["BLOCKER"] = "blocker";
    Priority["MINOR"] = "minor";
})($e073124ced5a2b69$export$300334f671c43555 || ($e073124ced5a2b69$export$300334f671c43555 = {}));
const $e073124ced5a2b69$export$33096039fd990cf4 = Object.keys($e073124ced5a2b69$export$fb587a27d5a722e7).length / 2;
const $e073124ced5a2b69$export$22aad1fd6cb58c70 = 255;
const $e073124ced5a2b69$export$938f0a0c059b7000 = 1500;
const $e073124ced5a2b69$export$fabaed2692852e55 = "firstInteractiveDemoIssueId";

});



parcelRegister("ekHfp", function(module, exports) {

var $fbsQc = parcelRequire("fbsQc");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fbsQc.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("gFMRp", function(module, exports) {

var $bJUVy = parcelRequire("bJUVy");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $c2366051d0d94979$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $bJUVy(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $c2366051d0d94979$var$cloneTypedArray;

});
parcelRegister("bJUVy", function(module, exports) {

var $2et7A = parcelRequire("2et7A");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $88c00e3d120aa9fa$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $2et7A(result).set(new $2et7A(arrayBuffer));
    return result;
}
module.exports = $88c00e3d120aa9fa$var$cloneArrayBuffer;

});


parcelRegister("2gQfZ", function(module, exports) {

var $46FN9 = parcelRequire("46FN9");

var $i0aei = parcelRequire("i0aei");

var $5wN9z = parcelRequire("5wN9z");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $1a759c80316d623d$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$5wN9z(object) ? $46FN9($i0aei(object)) : {};
}
module.exports = $1a759c80316d623d$var$initCloneObject;

});
parcelRegister("46FN9", function(module, exports) {

var $7jN5Q = parcelRequire("7jN5Q");
/** Built-in value references. */ var $2fd823ebdf752945$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $2fd823ebdf752945$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$7jN5Q(proto)) return {};
        if ($2fd823ebdf752945$var$objectCreate) return $2fd823ebdf752945$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $2fd823ebdf752945$var$baseCreate;

});

parcelRegister("i0aei", function(module, exports) {

var $a7ALC = parcelRequire("a7ALC");
/** Built-in value references. */ var $d1b02978e2299c10$var$getPrototype = $a7ALC(Object.getPrototypeOf, Object);
module.exports = $d1b02978e2299c10$var$getPrototype;

});


parcelRegister("3KWOe", function(module, exports) {

var $YhKXQ = parcelRequire("YhKXQ");

var $gu9fB = parcelRequire("gu9fB");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2bc3493bdbc1fb53$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $gu9fB(object, key, newValue);
        else $YhKXQ(object, key, newValue);
    }
    return object;
}
module.exports = $2bc3493bdbc1fb53$var$copyObject;

});

parcelRegister("kiLG8", function(module, exports) {

var $6tgvt = parcelRequire("6tgvt");

var $afOP0 = parcelRequire("afOP0");

var $h1PEc = parcelRequire("h1PEc");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $ec7a790fcabbc4b9$var$keysIn(object) {
    return $h1PEc(object) ? $6tgvt(object, true) : $afOP0(object);
}
module.exports = $ec7a790fcabbc4b9$var$keysIn;

});
parcelRegister("afOP0", function(module, exports) {

var $7jN5Q = parcelRequire("7jN5Q");

var $5wN9z = parcelRequire("5wN9z");

var $aZQUW = parcelRequire("aZQUW");
/** Used for built-in method references. */ var $7772ba3e7660e7e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7772ba3e7660e7e8$var$hasOwnProperty = $7772ba3e7660e7e8$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7772ba3e7660e7e8$var$baseKeysIn(object) {
    if (!$7jN5Q(object)) return $aZQUW(object);
    var isProto = $5wN9z(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$7772ba3e7660e7e8$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $7772ba3e7660e7e8$var$baseKeysIn;

});
parcelRegister("aZQUW", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8018a62d03f6675e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $8018a62d03f6675e$var$nativeKeysIn;

});



parcelRegister("el1aS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a703f014195acea4$var$_react = $a703f014195acea4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $a703f014195acea4$var$_link = $a703f014195acea4$var$_interopRequireDefault((parcelRequire("gLhLj")));
function $a703f014195acea4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a703f014195acea4$var$LinkIcon = (props)=>/*#__PURE__*/ $a703f014195acea4$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $a703f014195acea4$var$_link.default
    }));
$a703f014195acea4$var$LinkIcon.displayName = "LinkIcon";
var $a703f014195acea4$var$_default = module.exports.default = $a703f014195acea4$var$LinkIcon;

});

parcelRegister("2pEWv", function(module, exports) {

$parcel$export(module.exports, "PatternLogos", function () { return (parcelRequire("fXpYT")).PatternLogos; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("fXpYT")).PatternLogos; });

var $fXpYT = parcelRequire("fXpYT");

});
parcelRegister("fXpYT", function(module, exports) {

$parcel$export(module.exports, "PatternLogos", function () { return $bc1b089dcaa2a94e$export$355432025e812df1; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");

var $ix9oc = parcelRequire("ix9oc");

var $4XrxY = parcelRequire("4XrxY");
const $bc1b089dcaa2a94e$var$ConditionalLogo = (props)=>{
    if (props.link) return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: props.link,
        className: "logoblock logo-linked",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            src: props.src,
            alt: props.alt,
            width: props.width,
            loading: "lazy"
        })
    });
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        className: "logoblock logo-plain",
        src: props.src,
        alt: props.alt,
        width: props.width,
        loading: "lazy"
    }));
};
const $bc1b089dcaa2a94e$export$355432025e812df1 = ({ inlineLogos: inlineLogos, headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, linkPosition: linkPosition = "top" })=>{
    if (inlineLogos.length < 4 || inlineLogos.length > 12) throw new Error("Minimum 4 logos required, maximum 12");
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916ud5o _1nk71e5h _jti51ul9 _xjyridpf _2thuidpf _hbr3idpf",
            className
        ]),
        children: [
            headerText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                    isCentered: true,
                    headerText: headerText,
                    headerType: "h2",
                    eyebrowText: eyebrowText,
                    bodyText: bodyText,
                    ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : undefined
                })
            }) : null,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: `logos-content lgth length-${inlineLogos.length}`,
                    children: inlineLogos.map((inlineLogo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($bc1b089dcaa2a94e$var$ConditionalLogo, {
                            alt: inlineLogo.alt,
                            src: inlineLogo.src,
                            link: inlineLogo.link,
                            width: inlineLogo.width
                        }, index))
                })
            }),
            footNoteText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: "footnote-text",
                    children: footNoteText
                })
            }) : null,
            linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $7Knp0._)({}, ctaProps.primaryLinkProps))
                })
            }) : null
        ]
    });
};

});



var $f788Q = parcelRequire("f788Q");

var $i8zdv = parcelRequire("i8zdv");
(0, $f788Q.init)((0, $i8zdv.JiraSoftwareFeaturesPage));


//# sourceMappingURL=jira-software-features-page.cc309bac.js.map
